<template>
  <div class="title">
    <div class="title_name">{{passTitleData.titleName}}</div>
    <div class="comment">{{passTitleData.commentTxt}}</div>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: ["passTitleData"]
};
</script>

<style scoped>
.title > div {
  display: inline-block;
}
.title_name {
  line-height: 26px;
  padding-left: 8px;
  margin-right: 16px;
  border-left: 3px solid #0078ff;
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  font-family: RCB;
}
.comment {
  font-size: 14px;
  color: #4e5671;
  font-family: RCR;
  padding-right: 10px;
}
</style>